const ZeroState = () => {
  return <div style={{ textAlign: 'center' }}>There are no evaluations yet!</div>;
};

export default ZeroState;
